import React from 'react';
import './LTestimonials.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular

function LTestimonials() {
  // Todo el useEffect y GSAP ha sido eliminado
  return (
    <section className="social-proof">
      <div className="lp-container">
        <h2 className="section-title">Miles de personas ya estan hablando</h2>
        <div className="testimonials-marquee">
          <div className="testimonials-track">
            <div className="testimonial-card">
              <div className="testimonial-rating">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">"La combinacion de IA con profesores reales es genial. Practico con Spacy todos los dias y luego perfecciono con mi tutor. Mi ingles mejoro 10x!"</p>
              <div className="testimonial-author">— Maria G., Mexico</div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-rating">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">"La ruta guiada es increible. Por fin se exactamente que practicar cada dia. Mi confianza crecio un 300%."</p>
              <div className="testimonial-author">— Carlos R., </div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-rating">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">"Lo mejor es que puedo practicar a las 11 PM despues de trabajar. Spacy nunca me juzga y siempre esta disponible."</p>
              <div className="testimonial-author">— Ana L., Espana</div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-rating">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">"En 3 semanas mejore mas que en 2 anos de academia. El feedback personalizado es oro puro."</p>
              <div className="testimonial-author">— Luis M., Argentina</div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-rating">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">"Los mini games son adictivos. Aprender vocabulario nunca fue tan divertido. Ya voy por el nivel B2."</p>
              <div className="testimonial-author">— Sofia P., Chile</div>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-rating">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">"Las clases grupales en linea son perfectas. Conoci gente de toda Latinoamerica y practicamos juntos. Es como tener amigos de estudio!"</p>
              <div className="testimonial-author">— Diego F., Peru</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LTestimonials;